import {Component, OnDestroy, OnInit} from '@angular/core';
import {NotificationsEnums} from '@namespaces/notifications.namespace';
import {NotificationsProvider} from '@providers/notifications/notifications.provider';
import {Subscription} from 'rxjs';
import {ScrollToService} from '@services/scroll-to.service';
import {NotificationsGroup} from './notifications-group.class';
import {NotificationsGroupFactory} from './notifications-group-factory';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
})

export class NotificationsComponent implements OnInit, OnDestroy {
    /**
     * Отображаемые на текущей странице уведомления
     * @type {any[]}
     */
    public groupsToShow: NotificationsGroup[] = [];

    /**
     * Текущая отображаемая страница
     */
    public page = 1;

    /**
     * Страниц всего
     */
    public pagesCount = 1;

    /**
     * Статусы уведомлений для использования во View
     */
    public statuses = NotificationsEnums.Status;

    /**
     * Разбитые на страницы группы уведомлений
     * @type {{}}
     */
    private pagedGroups: PagedGroups = {};

    private subs: Subscription[] = [];

    /**
     * Сгруппированные уведомления, которые будут разбиты на страницы
     */
    private notiesGroups: NotificationsGroup[] = [];

    constructor(
        public provider: NotificationsProvider,
    ) {
    }

    ngOnInit() {
        this.subs.push(
            this.provider.data$.subscribe((data) => {
                this.notiesGroups = NotificationsGroupFactory.createGroups(data);
                this.pagedGroups = this.splitGroupsToPages(this.notiesGroups);
                this.setPage(this.page);
                this.readCurrentVisible();

            }, () => {
                this.notiesGroups = [];
                this.pagedGroups = this.splitGroupsToPages(this.notiesGroups);
                this.setPage(1);
            })
        );
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.provider.markNotiesAsRead();
    }

    onPageChange(page: number) {
        this.setPage(page);
        this.readCurrentVisible();
        ScrollToService.toTop();
    }

    /**
     * Прочитать все уведомления
     */
    readAll() {
        this.provider.realAll();
    }

    /**
     * Отметить прочитанными текущие непрочитанные уведомления
     */
    readCurrentVisible() {
        /**
         * Собираем ids непрочитанных уведомлений
         * @type {any[]}
         */
        const newIds = this.groupsToShow.reduce((acc, group) => {
            return acc.concat(...group.getNewItemsIds());
        }, []);

        if (!newIds.length) {
            return;
        }

        this.provider.readNoties(newIds);
    }

    removeNotification(id: number) {
        this.provider.removeNoty(id);
    }

    removeAll() {
        this.provider.removeAll();
    }

    private setPage(page: number = 1) {
        this.page = page;
        if (!this.pagedGroups[this.page] || !this.pagedGroups[this.page].length) {

            /**
             * Если страница была не первая, то попробуем перейти на предыдущую страницу
             */
            if (this.page > 1) {
                this.setPage(this.page - 1);
                return;
            }
            this.page = 1;
        }

        /**
         * Сохраняем группы для отображения иммутабельно, так как далее в исходных данных
         * мы будем отмечать уведомления прочитанными, чтобы они не менялись по ссылке
         * @type {any}
         */
        this.groupsToShow = this.pagedGroups[this.page];
        this.pagesCount = Object.keys(this.pagedGroups).length;
    }

    private splitGroupsToPages(groups: NotificationsGroup[]) {
        const countPerPage = 30;

        let currentPage = 1;

        const paged = {
            1: []
        };

        let currentPageItemsCount = 0;


        groups.forEach(group => {
            if (!paged[currentPage]) {
                paged[currentPage] = [];
            }

            paged[currentPage].push(group);
            currentPageItemsCount += group.items.length;

            if (currentPageItemsCount >= countPerPage) {
                currentPage++;
                currentPageItemsCount = 0;
            }

        });

        return paged;
    }
}

interface PagedGroups {
    [page: number]: NotificationsGroup[];
}
